export default {
  routes: [
    {
      name: 'employees',
      path: '/directory/employee',
      component: () => import('./views/TheEmployeePages.vue'),

    },

    {
      name: 'employee',
      path: '/directory/employee/:uuid',
      component: () => import('./views/TheEmployeePage.vue'),
    },
    {
      name: 'organizationsEmployeeCopy',
      path: '/directory/:uuid/organizations/:uuidOrganization/employee/:uuidEmployee/form',
      component: () => import('./organizations/views/TheOrganizationEmployeeCopy.vue')
    }
  ]
}
